import { render, staticRenderFns } from "./DashboardManagerDB.vue?vue&type=template&id=1248b92e"
import script from "./DashboardManagerDB.vue?vue&type=script&lang=ts"
export * from "./DashboardManagerDB.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1248b92e')) {
      api.createRecord('1248b92e', component.options)
    } else {
      api.reload('1248b92e', component.options)
    }
    module.hot.accept("./DashboardManagerDB.vue?vue&type=template&id=1248b92e", function () {
      api.rerender('1248b92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardManagerDB.vue"
export default component.exports